import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCondensedSeconds',
    standalone: false
})
export class FormatCondensedSecondsPipe implements PipeTransform {

    transform(value: number, options?: {
      includeSeconds?: boolean; showEmptyHours?: boolean; showEmptyMinutes?: boolean; returnEmptyString?: boolean;
    }): string {
        if (value === null || value === undefined || isNaN(value)) {
          return '';
        }

        const includeSeconds = options?.includeSeconds ?? false;
        const showEmptyHours = options?.showEmptyHours ?? true;
        const showEmptyMinutes = options?.showEmptyMinutes ?? true;
        const returnEmptyString = options?.returnEmptyString ?? true;

        if (returnEmptyString && value === 0) {
            return '';
        }

        const hours = Math.floor(value / 3600);
        const minutes = Math.floor(value % 3600 / 60);
        const seconds = Math.floor(value % 60);

        let result = '';
        if (hours > 0 || showEmptyHours) {
            result += `${hours}h `;
        }

        if (minutes > 0 || showEmptyMinutes) {
            result += `${minutes}m `;
        }

        if (includeSeconds && (seconds > 0 || showEmptyMinutes)) {
            result += `${seconds}s`;
        }
        return result.trim();
    }
}
